import Layout from '@/layouts/manage/manageLayout'

const manageRoute = [{
  path: '/manage',
  component: Layout,
  redirect: { name: 'AffiliateCid' },
  children: [{
    path: 'affiliate-cid',
    name: 'AffiliateCid',
    component: () => import('@/views/manage/affiliate-cid')
  }, {
    path: 'event',
    name: 'Event',
    component: () => import('@/views/manage/event')
  }, {
    path: 'event/add',
    name: 'EventAdd',
    component: () => import('@/views/manage/event/add')
  }, {
    path: 'event/edit/:eventOid',
    name: 'EventEdit',
    component: () => import('@/views/manage/event/add')
  }, {
    path: 'notification',
    component: Layout,
    children: [{
      path: '',
      name: 'NotificationList',
      component: () => import('@/views/manage/notification/index')
    }, {
      path: 'new',
      name: 'NotificationNew',
      component: () => import('@/views/manage/notification/create')
    }]
  }, {
    path: 'tool',
    name: 'Tool',
    component: () => import('@/views/manage/tool')
  }, {
    path: 'commission-rule',
    name: 'ToolCommissionRule',
    component: Layout,
    children: [{
      path: 'setting/:oid?',
      name: 'ToolCommissionRuleSetting',
      component: () => import('@/views/manage/tool/commission/save-commission')
    }, {
      path: 'view/:oid',
      name: 'ToolCommissionRuleView',
      component: () => import('@/views/manage/tool/commission/view-commission')
    }]
  }, {
    path: 'report/:cid',
    name: 'ManageReport',
    component: () => import('@/views/affiliate/report')
  }, {
    path: 'member-reward',
    name: 'ManageMember',
    component: () => import('@/views/manage/member-reward')
  }, {
    path: 'member-reward/prod-sponsor-application',
    name: 'ManageProdSponsorApplication',
    component: () => import('@/views/manage/member-reward/prod-sponsor-preview')
  }, {
    path: 'member-reward/fans-discount-application',
    name: 'ManageFansDiscountApplication',
    component: () => import('@/views/manage/member-reward/fans-discount-preview')
  }]
}, {
  path: '/manage/link-view/odoo', // 不需要 header
  name: 'LinkViewOdoo',
  component: () => import('@/views/manage/link-view/odoo/index.vue')
}, {
  path: '/commissionPaymentAttachment', // 不需要 header, 兼容 v1 已经存在的路由
  name: 'CommissionPaymentAttachment',
  component: () => import('@/views/manage/link-view/bpm/index.vue')
}]
export default manageRoute
